<script setup>
const props = defineProps(["class"]);
</script>

<template>
	<svg
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		:class="class"
	>
		<path
			d="M15.0007 15H13.334V7.84505L5.83403 15.3451L4.65564 14.1667L12.1556 6.66667H5.00069V5H15.0007V15Z"
			fill="currentColor"
		/>
	</svg>
</template>
